import type { Routes } from '@angular/router';
import { defaultPageOptions } from 'src/app/core/models';

export const pageNotFoundComponentRoutes: Routes = [
  {
    path: '**',
    loadComponent: () => import('./page-not-found.component').then((m) => m.AppPageNotFoundComponent),
    data: {
      page: defaultPageOptions,
    },
  },
];

export const page404ComponentRoutes: Routes = [
  {
    path: 'not-found',
    loadComponent: () => import('./page-not-found.component').then((m) => m.AppPageNotFoundComponent),
    data: {
      page: defaultPageOptions,
    },
  },
];
